import $ from 'jquery';
import { Swiper } from 'swiper';
import {
  Navigation,
  EffectCreative,
  EffectFade,
  Autoplay,
} from 'swiper/modules';

new Swiper('.testimonials-slider', {
  modules: [Navigation, EffectCreative],
  loop: false,
  slidesPerView: 1,
  centeredSlides: false,
  effect: 'creative',
  navigation: {
    nextEl: '.testimonials-slider-next',
    prevEl: '.testimonials-slider-prev',
  },
  creativeEffect: {
    limitProgress: 4,
    prev: {
      translate: [0, 0, -400],
      opacity: 0,
      scale: 0.2,
    },
    next: {
      translate: ['105%', 0, 0],
    },
  },
  breakpoints: {
    1200: {
      creativeEffect: {
        limitProgress: 4,
        next: { translate: ['calc(100% + 24px)', 0, 0] },
      },
    },
  },
});

new Swiper('.brands-slider', {
  modules: [Navigation, EffectCreative],
  loop: true,
  slidesPerView: 1,
  centeredSlides: true,
  effect: 'creative',
  autoHeight: false,
  navigation: {
    nextEl: '.brands-slider-next',
    prevEl: '.brands-slider-prev',
  },
  creativeEffect: {
    limitProgress: 2,
    prev: { translate: [0, 0, -400], opacity: 0, scale: 0.2 },
    next: { translate: ['330px', 0, 0] },
  },
  breakpoints: {
    768: {
      effect: 'creative',
      loop: false,
      creativeEffect: {
        limitProgress: 3,
        prev: { translate: [0, 0, -400], opacity: 0, scale: 0.2 },
        next: { translate: ['330px', 0, 0] },
      },
    },
  },
});

new Swiper('.brands-logo-slider', {
  modules: [Autoplay, EffectFade],
  autoplay: {
    delay: 5000,
  },
  slidesPerView: 1,
  effect: 'fade',
  loop: true,
});

const $sliderEl = $('.carousel-slider');

if ($sliderEl.length) {
  const imageCount = parseInt($sliderEl.data('count') as string, 10);

  const swiperOptions = {
    modules: [Autoplay],
    speed: 3000,
    slidesPerView: 'auto' as const,
    spaceBetween: 10,
    centeredSlides: false,
    loop: imageCount >= 3,
    autoplay:
      imageCount >= 3
        ? {
          delay: 0,
          disableOnInteraction: false,
        }
        : false,

    breakpoints: {
      1400: {
        loop: imageCount >= 8,
        autoplay:
          imageCount >= 8
            ? {
              delay: 0,
              disableOnInteraction: false,
            }
            : false,
      },
    },
  };

  new Swiper('.carousel-slider', swiperOptions);
}

const $cardsGridSlider = $('.cards-grid-slider.swiper');
$cardsGridSlider.each((_index: number, slider: HTMLElement) => {
  new Swiper(slider, {
    modules: [Navigation],
    slidesPerView: 'auto' as const,
    spaceBetween: 14,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      560: {
        loop: false,
      },
      992: {
        centeredSlides: false,
        loop: false,
      },
      1200: {
        centeredSlides: false,
        loop: false,
      },
      1300: {
        centeredSlides: false,
        slidesPerView: 4,
        loop: false,
      },
    },
  });
});

/* eslint-disable */
let userHasInteracted = false;
const video_slider = new Swiper('.videos-slider', {
  loop: true,
  slidesPerView: 1.2,
  centeredSlides: true,
  slideToClickedSlide: true,

  breakpoints: {
    768: {
      slidesPerView: 1.5,
    },
    992: {
      slidesPerView: 1.8,
    },
    1200: {
      slidesPerView: 2.3,
    },

    1800: {
      slidesPerView: 2.7,
    },
  },

  on: {
    touchEnd() {
      userHasInteracted = true;
    },
    click() {
      userHasInteracted = true;
    },
    slideChange() {
      resetInactiveVideos(this);

      // Ne pas lancer la vidéo tant que l'utilisateur n'a pas interagi
      if (!userHasInteracted) return;

      // @ts-ignore
      const activeSlide = $(this.slides[this.activeIndex]);
      const container = activeSlide.find('.yt-launcher, .vimeo-launcher');

      if (container.length) {
        playVideo(container);
      }
    },
  },
});
/* eslint-disable */

function resetInactiveVideos(video_slider: any) {
  const activeIndex = video_slider.realIndex;

  $('.swiper-slide').each(function (index) {
    if (index === activeIndex) return;

    const iframe = $(this).find('iframe');
    const img = $(this).find('img');
    const overlay = $(this).find('.video-overlay-title');

    iframe.attr('src', '');
    img.show();
    overlay.show();
    iframe.removeClass('show');
  });
}


function playVideo($container: any) {
  const overlay = $container.find('.video-overlay-title');
  const iframe  = $container.find('iframe');
  const img     = $container.find('img');

  const baseSrc = iframe.data('src');
  const separator = baseSrc.includes('?') ? '&' : '?';
  const srcUrl = baseSrc + separator + 'autoplay=1&mute=1';

  iframe.attr('src', srcUrl);
  overlay.hide();
  img.hide();
  iframe.addClass('show');
}

new Swiper('.cta-slider', {
  modules: [Navigation],
  loop: false,
  slidesPerView: 1,
  spaceBetween: 16,
  navigation: {
    nextEl: '.cta-slider-next',
    prevEl: '.cta-slider-prev',
  },
});
